export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS"
export const GET_ORDER_ERROR = "GET_ORDER_ERROR"


export const GET_ORDER_DETAIL_SUCCESS = "GET_ORDER_DETAIL_SUCCESS"
export const GET_ORDER_DETAIL_ERROR = "GET_ORDER_DETAIL_ERROR"

